import React, { FunctionComponent, MouseEvent, PointerEvent } from 'react';
import { useDispatch, useSelector, } from 'react-redux';

import { AppDispatch, RootState } from "../../store/store";

import { useTranslation } from 'react-i18next';
import { push } from '@lagunovsky/redux-react-router';

import './Footer.css';
import { macs365Uri } from '../../uris';
import {
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  SelectChangeEvent,
} from '@mui/material';
import { LanguageCode, languageTypes } from '../../i18n/i18n';
import { languageChanged, langUpdated } from '../../App/app';

interface Props {
  language?: boolean
}

const Footer: FunctionComponent<Props> = ( props ) => {

  const language = props.language === false ? false : true;

  const dispatch = useDispatch<AppDispatch>();
  const lang = useSelector( ( state: RootState ) => state.app.language );
  const { t } = useTranslation( [ 'footer' ] );

  const onLanguageChanged = ( event: SelectChangeEvent ) => {
    const target = event.target as HTMLInputElement;
    const code = target.value as LanguageCode;

    dispatch( languageChanged( code ) );

    // Store selection permanently
    dispatch( langUpdated( code ) );
  };

  const onLink = ( event: MouseEvent ) => {

    event.preventDefault();

    const target = event.target as HTMLAnchorElement;
    dispatch( push( new URL( target.href ).pathname ) );
  };

  return (
    <Container>
      <footer className="footer">
        <span className="footer-text">© Copyright { new Date().getFullYear() } Hella Gutmann Solutions GmbH</span>
        <a
          href="https://www.hella-gutmann.com/fileadmin/Manuals/html/datenschutzerklaerung-/-privacy-statement/index.html"
          target="_blank"
          className="footer-link"
        >{ t( 'data-privacy-policy' ) }</a>
        <div className='footer-link__break'></div>
        <a
          href="/faq"
          onClick={ onLink }
          className="footer-link"
        >{ t( 'faq' ) }</a>
        <a
          href="/imprint"
          onClick={ onLink }
          className="footer-link"
        >{ t( 'imprint' ) }</a>
        {language && <FormControl sx={ { minWidth: 80 } } size="small">
          <Select
            value={ lang }
            onChange={ onLanguageChanged }
            displayEmpty
          >
            { languageTypes.map( ( { code, language }) => (
              <MenuItem key={ code } value={ code }>{ language }</MenuItem>
            ))}
          </Select>
        </FormControl>}

      </footer>
    </Container>
  );
}

export default Footer;
